import {
  SET_ON_TYPING,
  SET_IS_CHAT_ENABLED,
  SET_MESSAGE_LIST,
  SET_IS_AGENT_CONNECTED,
  SET_SOUND_OFF,
  SET_MESSAGE_TO_SEND,
  SET_DELIVERED_MESSAGE_ID,
  SET_READ_MESSAGE_ID,
  SET_IS_CUSTOMER_MESSAGE_IN_VIEW,
} from "./types";
import {
  UnKnownError,
  NetworkingError,
  SendMessageUnexpectedError,
} from "../../common/CustomError";
import { setError } from "../../redux/actions/errorActions";

import { config } from "../../components/Chat/Chat";
import {
  setChatHeaderTitle,
  setUnreadMessageCount,
  renderChat,
} from "./chatActions";
import {
  onMessageFunc,
  sendChatMessageToConnect,
} from "./amazonConnectActions";
import moment from "moment";
import {
  playAudio,
  extractAliasFromEmail,
  checkForTestScenario,
  uuidv4,
  scrollDown,
} from "../../common/ChatUtil";
import { getConnectAttributes } from "../../api/ChatAPI";
import store from "../../redux";
import DOMPurify from "dompurify";
import { debuglogger } from "../../common/debugLogger";

export const setDeliveredMessageId = (messageId) => (dispatch) => {
  try {
    //if (store.getState().messagePaneReducer.deliveredMessageId !== messageId)
    dispatch({ type: SET_DELIVERED_MESSAGE_ID, payload: messageId });
  } catch (error) {
    console.error("setDeliveredMessageId Error", error);
  }
};

export const setReadMessageId = (messageId) => (dispatch) => {
  try {
    //if (store.getState().messagePaneReducer.deliveredMessageId !== messageId)
    dispatch({ type: SET_READ_MESSAGE_ID, payload: messageId });
  } catch (error) {
    console.error("setReadMessageId Error", error);
  }
};

export const setOnTyping = (onTyping) => (dispatch) => {
  try {
    if (store.getState().messagePaneReducer.onTyping !== onTyping) {
      dispatch({ type: SET_ON_TYPING, payload: onTyping });
    }
  } catch (error) {
    console.error("setOnTyping Error", error);
  }
};

export const setIsChatEnabled = (isChatEnabled) => (dispatch) => {
  try {
    dispatch({ type: SET_IS_CHAT_ENABLED, payload: { isChatEnabled } });
  } catch (error) {
    console.error("setIsChatEnabled Error", error);
  }
};

export const clearMessageList = () => (dispatch) => {
  try {
    dispatch({ type: SET_MESSAGE_LIST, payload: [] });
  } catch (error) {
    console.error("clearMessageList Error", error);
  }
};

export const setIsAgentConnected = (isAgentConnected) => (dispatch) => {
  try {
    if (
      store.getState().messagePaneReducer.isAgentConnected !== isAgentConnected
    ) {
      dispatch({ type: SET_IS_AGENT_CONNECTED, payload: isAgentConnected });
    }
  } catch (error) {
    console.error("setIsAgentConnected Error", error);
  }
};

export const setIsCustomerMessageInView =
  (isCustomerMessageInView) => (dispatch) => {
    try {
      if (
        store.getState().messagePaneReducer.isCustomerMessageInView !==
        isCustomerMessageInView
      ) {
        dispatch({
          type: SET_IS_CUSTOMER_MESSAGE_IN_VIEW,
          payload: isCustomerMessageInView,
        });
      }
    } catch (error) {
      console.error("setIsCustomerMessageInView Error", error);
    }
  };

export const setSoundOff = (soundOff) => (dispatch) => {
  try {
    if (store.getState().messagePaneReducer.soundOff !== soundOff) {
      dispatch({ type: SET_SOUND_OFF, payload: soundOff });
    }
  } catch (error) {
    console.error("setSoundOff Error", error);
  }
};
export const setMessageToSend = (messageToSend) => (dispatch) => {
  try {
    if (store.getState().messagePaneReducer.messageToSend !== messageToSend) {
      dispatch({ type: SET_MESSAGE_TO_SEND, payload: messageToSend });
    }
  } catch (error) {
    console.error("setMessageToSend Error", error);
  }
};

export const scrubMessageFromInputContainer =
  (bypassOktaAccessToken = true) =>
  async (dispatch) => {
    try {
      const messageToSend = DOMPurify.sanitize(
        store.getState().messagePaneReducer.messageToSend
      );
      debuglogger(
        "Entered scrubMessageFromInputContainer()" +
          "\nmessageToSend: " +
          messageToSend +
          "\nbypassOktaAccessToken " +
          bypassOktaAccessToken
      );
      /* console.error("Entered scrubMessageFromInputContainer()", {
        messageToSend,
        bypassOktaAccessToken,
      }); */

      if (!messageToSend || messageToSend.length === 0) return;

      if (store.getState().messagePaneReducer.isChatEnabled.isNetworkError) {
        throw new NetworkingError("There is network error");
      }

      // Type 'test technical error' to simulate a technical error scenario
      // Below if block represents the above comment
      if (
        checkForTestScenario(messageToSend, "trigger-technical-error", true)
      ) {
        const messageObjList = dispatch(
          onMessageFunc(
            {
              data: {
                Type: "MESSAGE",
                DisplayName: "SYSTEM_MESSAGE",
                ParticipantRole: "SYSTEM",
                ParticipantId: "Dummy",
                InitialContactId:
                  store.getState().amazonConnectReducer.initialContactId,
                ContactId:
                  store.getState().amazonConnectReducer.currentContactId,
                ContentType: "application/json",
                Content:
                  "We have experienced a technical error, so you will have to restart your chat. You will  be asked to provide your information again. We apologize for any inconvenience you may encounter.",
                AbsoluteTime: Date.now(),
                id: "mocktest" + uuidv4(),
              },
              chatDetails: {
                contactId:
                  store.getState().amazonConnectReducer.currentContactId,
              },
            },
            undefined,
            true
          )
        );
        dispatch(addMessage(messageObjList, true));
      } else if (
        !bypassOktaAccessToken &&
        config.customerFacing === "true" &&
        !config.oktaAccessToken.startsWith("UNAUTHENTICATED")
      ) {
        notifyParent("getOktaAndScrub");
      } else {
        try {
          dispatch(sendChatMessageToConnect(messageToSend, true)); //update message in case of error and send the message. Jumping dots will be hidden
        } catch (error) {
          if (
            !store.getState().messagePaneReducer.isChatEnabled.restartFlag &&
            !store.getState().messagePaneReducer.isChatEnabled.isNetworkError
          ) {
            // on UnKnownError proceed with unscrub data to send message to connect
            if (error instanceof UnKnownError) {
              dispatch(
                setError({
                  error: new SendMessageUnexpectedError(error.message),
                  retryAction: () => {
                    dispatch(sendChatMessageToConnect(messageToSend, false)); //update message in case of error and send the message. Jumping dots will be hidden
                  },
                  errorCode: "E008",
                })
              );
            } else {
              dispatch(
                setError({
                  error: error,
                  retryAction: () =>
                    scrubMessageFromInputContainer(bypassOktaAccessToken),
                  errorCode: "E009",
                })
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("scrubMessageFromInputContainer Error", error);
    }
  };

export const undoAddMessage = (id) => (dispatch) => {
  try {
    let messageList = store.getState().messagePaneReducer.messageList;
    const itemToRemove = messageList.findIndex((item) => item.id === id);
    debuglogger(
      "undoAddMessage rollback the last message from messagelist" +
        itemToRemove +
        "userMessageObjId: " +
        id +
        "lastMessage: " +
        messageList[messageList?.length - 1]
    );
    /*  console.error("undoAddMessage rollback the last message from messagelist", {
      itemToRemove,
      userMessageObjId: id,
      lastMessage: messageList[messageList.length - 1],
    }); */
    if (itemToRemove !== -1) {
      messageList.splice(itemToRemove, 1);
    }
    dispatch({ type: SET_MESSAGE_LIST, payload: messageList });
  } catch (error) {
    console.error("undoAddMessage Error", error);
  }
};

export const replaceMessage = (id, messageText) => (dispatch) => {
  try {
    let messageList = store.getState().messagePaneReducer.messageList;
    const itemToReplace = messageList.findIndex((item) => item.id === id);

    debuglogger(
      "replaceMessage message " +
        "\nitemToReplace:" +
        itemToReplace +
        "\nuserMessageObjId: " +
        id +
        "\nlastMessage: " +
        messageList[messageList?.length - 1]
    );
    if (itemToReplace !== -1) {
      messageList[itemToReplace] = {
        ...messageList[itemToReplace],
        messageText,
      };
    }
    dispatch({ type: SET_MESSAGE_LIST, payload: messageList });
  } catch (error) {
    console.error("undoAddMessage Error", error);
  }
};

export const addMessage =
  (addMessageObjList, fromWebSocket = false, emptyListBeforeAdd = false) =>
  async (dispatch) => {
    if (!addMessageObjList || addMessageObjList.length === 0) {
      return;
    }

    // transform the addMessageObjList to newMessageList object
    const newMessageList = addMessageObjList.map((addMessageObj) => {
      return {
        ...addMessageObj,
        isAgent: addMessageObj.userType === "AGENT",
        isSystem: addMessageObj.userType === "SYSTEM",
        isEvent: addMessageObj.userType === "EVENT",
        isCustomer: addMessageObj.userType === "CUSTOMER",
        displayUserName: undefined,
        repAlias: undefined,
        displayTimeStamp: Date.now(),
        readDeliveryStatus: undefined,
      };
    });
    let messageListToDisplay = emptyListBeforeAdd
      ? []
      : store.getState().messagePaneReducer.messageList;

    // if message.id does not exist in messageListToDisplay, then find the index of where to insert it in the messageListToDisplay based in the accending order by messageTime
    let lastMessage =
      messageListToDisplay.length === 0
        ? newMessageList[0]
        : messageListToDisplay[messageListToDisplay.length - 1];

    newMessageList.forEach((newMessage, i) => {
      let insertIndex = -1;
      let found = messageListToDisplay.some((msg) => msg.id === newMessage.id);

      let aTempMessageFound = false;
      if (!found && newMessage.isCustomer) {
        messageListToDisplay.forEach((msg) => {
          if (!aTempMessageFound && msg.id.startsWith("aTempMessage")) {
            msg.id = newMessage.id;
            msg.messageTime = newMessage.messageTime;
            aTempMessageFound = true;
            msg.displayUserName = newMessage.displayUserName;
            msg.messageUserName = newMessage.messageUserName;
            msg.contactId = newMessage.contactId;
            msg.contentType = newMessage.contentType;
          }
        });
      }

      //   checkForTestScenario(
      //     addMessageObjList[0].messageText,
      //     "trigger-addmessage-exception",
      //     fromWebSocket,
      //     new Error("Error while adding message to messageListToDisplay.")
      //   );

      found = messageListToDisplay.some((msg) => msg.id === newMessage.id);
      if (!found) {
        insertIndex = messageListToDisplay.findIndex((msg) =>
          moment(msg.messageTime).isAfter(moment(newMessage.messageTime))
        );
        //Add delay to system messages that are received back to back.
        if (
          messageListToDisplay.length > 0 &&
          fromWebSocket &&
          insertIndex === -1
        ) {
          if (newMessage.messageText?.type === "quickReplies" && lastMessage) {
            newMessage.delayMessage = lastMessage.delayMessage;
            newMessage.displayTimeStamp = lastMessage.displayTimeStamp;
          } else {
            const delayInMilliSec =
              750 -
              (newMessage.displayTimeStamp - lastMessage.displayTimeStamp);

            if (
              lastMessage.isSystem &&
              newMessage.isSystem &&
              delayInMilliSec > 0 &&
              newMessage.messageTime >= lastMessage?.messageTime
            ) {
              newMessage.delayMessage = delayInMilliSec;
              newMessage.displayTimeStamp =
                newMessage.displayTimeStamp + delayInMilliSec;
              setTimeout(() => {
                playAudio(false);
                const sameMessageIdList = document.querySelectorAll(
                  "#" + newMessage.id + ",#" + newMessage.id + "qr"
                );
                sameMessageIdList.forEach((element) => {
                  element.hidden = false;
                });
                newMessage.delayMessage = undefined;
                const qrValue = messageListToDisplay.find(
                  (row) => row.id === newMessage.id + "qr"
                );
                if (qrValue) {
                  qrValue.delayMessage = undefined;
                }

                //perform autoscroll
                const chatMessageContainer = document.querySelector(
                  ".messageListContainer"
                );
                if (chatMessageContainer) {
                  chatMessageContainer.scrollTop =
                    chatMessageContainer.scrollHeight;
                }
              }, delayInMilliSec);
            }
          }
          lastMessage = newMessage;
        }

        // play the chime when message from agent or system is recievedif there is no delay set, otherwise the chime will be play after the delay elapsed.
        if (
          !newMessage.delayMessage &&
          newMessage.messageText?.type !== "quickReplies" &&
          (newMessage.isAgent || newMessage.isSystem) &&
          fromWebSocket
        ) {
          playAudio(false);
        }
        // only play the jingle when adding the event to the messageListToDisplay for the first time.
        if (
          newMessage.isEvent &&
          newMessage.messageText.includes("joined the chat")
        ) {
          playAudio(true);
          dispatch(setIsAgentConnected(true));
          dispatch(setChatHeaderTitle(newMessage.messageUserName));
        }

        if (
          newMessage.isSystem &&
          newMessage.messageText ===
            "We have experienced a technical error, so you will have to restart your chat. You will  be asked to provide your information again. We apologize for any inconvenience you may encounter."
        ) {
          dispatch(
            setIsChatEnabled({
              restartFlag: true,
            })
          );
        }

        if (newMessage.isSystem) {
          dispatch(setIsAgentConnected(false));
          dispatch(setChatHeaderTitle("State Farm Virtual Assistant"));
        }

        //Sort the messageListToDisplay by ascending messageTime.
        messageListToDisplay.splice(
          insertIndex === -1 ? messageListToDisplay.length : insertIndex,
          0,
          newMessage
        );
      }
    });

    // Post addMessage to messageListToDisplay processing:
    //  1) add repAlias for internal facing chat
    //  2) add displayUserName property to each message for displaying the UserName & timestamp label in the message list.

    let lastRepJoined;
    let lastUser = "";
    for await (let msg of messageListToDisplay) {
      // Add repAlias for internal facing chat
      if (config.customerFacing === "false") {
        if (msg.isEvent && msg.messageText.includes("joined the chat")) {
          try {
            lastRepJoined = await getRepAlias(
              msg.repAlias,
              msg.contactId,
              dispatch
            );
            msg.repAlias = lastRepJoined;
            if (!msg.messageText.includes(msg.repAlias)) {
              msg.messageText = msg.messageText.replace(
                " joined the chat.",
                " (" + msg.repAlias + ") joined the chat."
              );
            }
          } catch (e) {
            console.error("error on getRepAlias", e);
          }
        } else if (msg.isAgent && lastRepJoined) {
          msg.repAlias = lastRepJoined;
        }
      }

      //Add displayUserName property.
      const currentUser = msg.isAgent
        ? "AGENT"
        : msg.isSystem
        ? "SYSTEM"
        : msg.isCustomer
        ? "CUSTOMER"
        : "EVENT" + msg.messageUserName;
      msg.displayUserName = lastUser !== currentUser;
      lastUser = currentUser;
    }
    dispatch(setOnTyping(false));
    notifyParent({
      message: "chatNotifEventNavi",
    });

    dispatch(setNotificationOnTab(true));
    debuglogger(
      "***redux after adding newMessageList to messageListToDisplay: " +
        newMessageList +
        messageListToDisplay
    );
    /* console.error(
      "***redux after adding newMessageList to messageListToDisplay: ",
      {
        newMessageList,
        messageListToDisplay,
      }
    ); */

    try {
      if (store.getState().chatReducer.render.loaderPane) {
        dispatch(
          renderChat({
            from: "15",
            messagePane: { messagePaneReady: true },
          })
        );
      }
      dispatch({ type: SET_MESSAGE_LIST, payload: messageListToDisplay });
    } catch (error) {
      console.error("addMessage Error", error);
    }
  };

async function getRepAlias(repAlias, contactId, dispatch) {
  try {
    if (repAlias) {
      return repAlias;
    } else {
      const response = await getConnectAttributes(config, contactId, [
        "agent_username",
      ]);
      return extractAliasFromEmail(response?.body?.agent_username)?.alias;
    }
  } catch (error) {
    dispatch(
      setError({
        error: error,
        retryAction: () => getRepAlias(repAlias, contactId),
        errorCode: "E007",
      })
    );
  }
}

export const resetUnreadNotif = () => (dispatch) => {
  scrollDown();
  dispatch(setUnreadMessageCount(0));
  notifyParent({
    message: "offTileMessage",
    value: 0,
    chatWindowOpned: store.getState().chatReducer.chatWidgetOpened,
  });
};

export const setNotificationOnTab = (tabInactive) => (dispatch) => {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      dispatch(resetUnreadNotif());
    }
  });

  if (tabInactive) {
    if (document.hidden || !store.getState().chatReducer.chatWidgetOpened) {
      const unreadMessageCount =
        store.getState().chatReducer.unreadMessageCount + 1;
      dispatch(setUnreadMessageCount(unreadMessageCount));
      notifyParent({
        message: "onTileMessage",
        value: unreadMessageCount,
        chatWindowOpned: store.getState().chatReducer.chatWidgetOpened,
      });
    }
  }
  // } else {
  //   notifyParent({
  //     message: "chatNotifEventNavi",
  //   });
  // }
  // else {
  //   dispatch(setUnreadMessageCount(0));
  //   notifyParent({
  //     message: "offTileMessage",
  //     value: 0,
  //     chatWindowOpned: store.getState().chatReducer.chatWidgetOpened,
  //   });
  // }
};

//TODO - move to ChatUtil
const notifyParent = (message) => {
  const newMessage = {
    message: message,
    ChatId: config.ChatId,
  };
  // eslint-disable-next-line no-restricted-globals
  if (parent) parent.postMessage(newMessage, "*");
};
